<template>
  <div>
    <el-row>
      <!-- List of login record  / settings -->
      <el-col :span="24">
        <SSRTable :data-url="urlLoginRecords" :schema="cols" data-key="audit_auth_logs"
          :search-on="['account_id', 'type', 'created_at', 'client_ip', 'country', 'device']">
        </SSRTable>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import SSRTable from 'src/components/SSRTable';
import axios from 'axios';

export default {
  components: {
    SSRTable
  },

  mounted() {
    this.fetchRecords()
  },

  methods: {
    fetchRecords() {
      axios.get(`${process.env.VUE_APP_APIHOST}/gaa/login/users`)
      .then(response => {
        this.loginRecords = response.data.audit_auth_logs;
        console.log(`[LOGIN RECORD] Obtained list of loginRecords`, this.loginRecords);
      })
      .catch(err => {
        console.error(`[LOGIN RECORD] Cannot fetch record list`, err);
        this.$notify.error({
          title: '查詢錯誤 - 登入列表',
          message: err.data.message
        });
      });
    }
  },

  data() {
    return {
      cols: [
        { key: 'account_id', label: '帳戶ＩＤ', width: 108 },
        { key: 'type', label: '登入類型', width: 108 },
        { key: 'created_at', label: '登入日期' },
        { key: 'client_ip', label: '登入ＩＰ' },
        { key: 'country', label: '國家', width: 108 },
        { key: 'device', label: '裝置類型' },
      ],
      loginRecords: []
    };
  },

  computed: {
    urlLoginRecords() {
      return `${process.env.VUE_APP_APIHOST}/gaa/login/users`
    }
  }
}
</script>